<template>
  <v-dialog width="450px" v-model="showModal" persistent>
    <v-card>
      <v-card-title class="headline text-center">
        <strong>Finalizar multa/avaria</strong>
      </v-card-title>

      <v-card-text>
        <v-textarea v-model="motivo" label="Observação:" required></v-textarea>
      </v-card-text>
      <v-card-actions class="text-center align-center">
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" @click="hideModal">
          Cancelar
        </v-btn>
        <v-btn color="green darken-1" @click="$emit('btnSim', motivo)">
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import UserCreditCardController from '../../controllers/UserCreditCardController';
export default {
  props: {
    showModal: Boolean,
    transacao: Object,
  },
  data() {
    return {
      motivo: '',
    };
  },

  methods: {
    clearForm() {
      this.motivo = '';
    },
    hideModal() {
      this.clearForm();
      this.$emit('btnNao');
    },
  },
};
</script>
